import { lazy } from 'react';

const List = lazy(() => import('pages/crud'));
const Product = lazy(() => import('pages/product'));
const ProductView = lazy(() => import('pages/product/productDetails'));

const productsRoutes = [
    {
        path: '/app/produtos',
        name: 'Produtos',
        component: List,
        exact: true,
        title: 'Produtos'
    },
    {
        path: '/app/produtos/novo',
        name: 'Novo produto',
        component: Product,
        exact: true,
        title: 'Novo produto'
    },
    {
        path: '/app/produtos/editar/:id',
        name: 'Editar',
        component: Product,
        exact: true,
        title: 'Editar produto'
    },
    {
        path: '/app/produtos/ver/:id',
        name: 'Visualizar',
        component: ProductView,
        exact: true,
        title: 'Visualizar Produto'
    }
];

export default productsRoutes;
